var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountBlockedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 10.5,
    fill: "#212529",
    stroke: "#212529"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_888_5833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9.53704H7.25C6.91848 9.53704 6.60054 9.67361 6.36612 9.91671C6.1317 10.1598 6 10.4895 6 10.8333V15.3704C6 15.7142 6.1317 16.0439 6.36612 16.287C6.60054 16.5301 6.91848 16.6667 7.25 16.6667H14.75C15.0815 16.6667 15.3995 16.5301 15.6339 16.287C15.8683 16.0439 16 15.7142 16 15.3704V10.8333C16 10.4895 15.8683 10.1598 15.6339 9.91671C15.3995 9.67361 15.0815 9.53704 14.75 9.53704H13.5M8.5 9.53704V7.59259C8.5 6.90499 8.76339 6.24556 9.23223 5.75935C9.70107 5.27315 10.337 5 11 5C11.663 5 12.2989 5.27315 12.7678 5.75935C13.2366 6.24556 13.5 6.90499 13.5 7.59259V9.53704M8.5 9.53704H13.5M11 12.1296V14.0741",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_888_5833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 14,
    fill: "white",
    transform: "translate(5 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountBlockedIcon);
export default __webpack_public_path__ + "static/media/account-blocked-icon.ac0f5db6640508ec8c47d96d25fc5c7b.svg";
export { ForwardRef as ReactComponent };